import React, { useState } from 'react';
import { useEffect } from 'react';
import ReactBnbGallery from 'react-bnb-gallery';
import { S3_BUCKET } from '../constants';

// Below line imports the css that is necessary to display opened images
import 'react-bnb-gallery/dist/style.css'

export function ImageViewer({ images }) {
    const [isOpen, setIsOpen] = useState(false);
    const [photos, setPhotos] = useState([]);

    useEffect(() => {
        const photos = [];
        images.map(image => {
            photos.push({
                photo: S3_BUCKET + image.path
            })
        });
        setPhotos(photos);
    }, [images])
    return <ul>
        {
            images.map((image, index) => {
                return <li key={index}>
                    <button>
                        <img onClick={() => setIsOpen(true)}
                            src={S3_BUCKET + image.path} className="img-fluid" alt="" />
                    </button>
                    <ReactBnbGallery
                        show={isOpen}
                        photos={photos}
                        onClose={() => setIsOpen(false)}
                        showThumbnails={false}
                    />
                </li>
            })}
    </ul>
}